
export default {
  name: "YotpoWidget",

  inject: { pageType: { default: "" } },

  props: { slice: { type: Object, required: true } },

  head() {
    return {
      script: this.slice.primary.script_source
        ? [
            {
              src: this.slice.primary.script_source,
              body: true,
              async: true,
            },
          ]
        : [],
    };
  },

  computed: {
    isMember() {
      return this.pageType === "Become_a_member";
    },
  },

  mounted() {
    this.$nextTick(() => {
      if (typeof window !== "undefined" && window.yotpoLoader) {
        window.yotpoLoader.load();
      }
    });
  },
};
